<ng-container *ngIf="selected; else unchecked">
  <app-selected-icon></app-selected-icon>
</ng-container>

<ng-template #unchecked>
  <app-icon name="selected-item-composition-background"></app-icon>
</ng-template>